/** Presets are not an allowlist when the supplier/product exposes a numeric range.
 * Keep range validation separate from generic radio/select auto-correction.
 */
export function acceptsCustomQuantitySelection(
  option: { id: string; name?: string; type?: string; values?: Array<{ type?: string; value?: unknown }>; min?: number; max?: number },
  value: unknown,
  settings?: { type?: string; minimum?: number; maximum?: number; min?: number; max?: number; step?: number },
  policy?: { type?: string; exact?: boolean; minimum?: number; maximum?: number; min?: number; max?: number; ranges?: Array<{ min?: number; max?: number; minimum?: number; maximum?: number; step?: number; steps?: number }> } | null,
): boolean {
  if (option.id !== 'copies' && option.name !== 'copies') return false;
  if (policy?.type === 'fixed' || policy?.exact === true || (!policy && settings?.type === 'fixed')) return false;
  const open = Boolean(policy) || settings?.type === 'preset-plus-custom' || settings?.type === 'minimum' || option.type === 'number'
    || option.values?.some(item => item.type === 'digital' || item.value === '');
  const n = Number(value);
  if (!open || !Number.isSafeInteger(n) || n < 1) return false;
  const minimum = Number(policy?.minimum ?? policy?.min ?? settings?.minimum ?? settings?.min ?? option.min ?? 1);
  const maximum = Number(policy?.maximum ?? policy?.max ?? settings?.maximum ?? settings?.max ?? option.max ?? Number.MAX_SAFE_INTEGER);
  if (n < minimum || n > maximum) return false;
  // Sets (bijv. per 3 stuks) uit open-custom-quantity.ts.
  const step = Number(!policy ? settings?.step : undefined);
  if (Number.isSafeInteger(step) && step > 1 && n % step !== 0) return false;
  if (policy?.ranges?.length) return policy.ranges.some(range => {
    const min = Number(range.min ?? range.minimum);
    const max = Number(range.max ?? range.maximum);
    const step = Number(range.step ?? range.steps ?? 1);
    return n >= min && n <= max && step > 0 && (n - min) % step === 0;
  });
  return true;
}
